import { SerializedStyles } from "@emotion/react";
import { ReactNode, memo, useCallback } from "react";

import { notUndefinedOrNull } from "@fraction/shared";

import Checkbox from "../Checkbox";

export interface CheckboxGenericValueProps<ValueType> {
  checked?: boolean;
  onChange?: (checked: boolean, value: ValueType) => void;
  value?: ValueType;
  style?: SerializedStyles;
  labelStyle?: SerializedStyles;
  label?: string;
  large?: boolean;
  children?: ReactNode;
}

function CheckboxGenericValue<ValueType>({
  onChange,
  value,
  ...props
}: CheckboxGenericValueProps<ValueType>) {
  const handleChange = useCallback(
    (checked: boolean) => {
      // Avoiding here a surprise if the value is the number 0
      if (notUndefinedOrNull(value)) {
        onChange?.(checked, value);
      }
    },
    [onChange, value]
  );

  return <Checkbox onChange={handleChange} {...props} />;
}

export default memo(CheckboxGenericValue) as typeof CheckboxGenericValue;
